module.exports = __webpack_public_path__ + "img/btn_user_work_upload.1260a5fe.png";